/*
 * AccountPage
 *
 * This is the first thing users see of our App, at the '/' route
 *
 */

import React from 'react';
import { Footer } from '../../features/footer/Footer';
import { Header } from '../../features/header/Header';
import { Container, Row, Col, Button, Card, Label } from 'reactstrap';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { withAuthentication } from '../../common/authentication';

import { injectIntl, FormattedMessage } from 'react-intl';
import messages from './messages';
import config from '../../config';

function AccountPage({ intl, authState: { username } }) {
  return (
    <>
      <Header />
      <Container>
        <Helmet>
          <title>{intl.formatMessage(messages.title)}</title>
          <meta
            name="description"
            content={intl.formatMessage(messages.metaDesc)}
          />
        </Helmet>
        <Card />
        <h1 className="tpicap-h mb-4">
          <FormattedMessage {...messages.header} />
        </h1>
        <Row className="mb-2">
          <Col>
            <Label>
              <h6>
                <FormattedMessage {...messages.usernameField} />
              </h6>
              <div>{username ? username : ''}</div>
            </Label>
          </Col>
          <Col></Col>
        </Row>
        <Row>
          <Col>
            <FormattedMessage
              {...{
                ...messages.changeInstructions,
                values: {
                  supportLink: (
                    <a
                      href={`mailto:${intl.formatMessage(
                        messages.contactEmail,
                      )}`}
                    >
                      {intl.formatMessage(messages.clientServicesName)}
                    </a>
                  ),
                },
              }}
            />{' '}
          </Col>
        </Row>
        <h4 className="pt-2 tpicap-sh mb-3">
          <FormattedMessage {...messages.resetPasswordSectionHeader} />
        </h4>
        <div className="mt-4 mb-5">
          <Button
            outline
            color="default"
            href={config.oktaAccountManagementLink}
          >
            <FormattedMessage
              {...{
                ...messages.passwordLinkText,
              }}
            />
          </Button>
        </div>
      </Container>
      <Footer shape={false} />
    </>
  );
}

export default withRouter(withAuthentication(injectIntl(AccountPage)));
